// extracted by mini-css-extract-plugin
export default {"comments":"comments_comments__6Zvxf"};